export default "<div [chart]=\"temperatureInstant\"></div>"